// extracted by mini-css-extract-plugin
module.exports = {"parameters":"parameters_parameters__z6R9h","select":"parameters_select__PRFQH"};